import React from 'react'

import {ButtonLink} from '@vio/atlas/ButtonLink'
import {Icon} from '@vio/atlas/Icon'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {myListMessages} from '../../myListMessages'

interface Props {
  isToggleOn: boolean
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void
  className?: string
}

export const PriceWatchLinkButton = ({
  isToggleOn,
  handleClick,
  className
}: Props) => {
  // An anchor without an href ignores Enter and Space on its own
  const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    handleClick(event)
  }

  return (
    <ButtonLink
      className={className}
      role="button"
      tabIndex={0}
      aria-pressed={isToggleOn}
      dataId={isToggleOn ? 'PriceWatchLinkButtonOn' : 'PriceWatchLinkButton'}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      iconStart={
        <Icon
          name={isToggleOn ? 'HeartFilled' : 'Heart'}
          size="sm"
          colorPath={isToggleOn ? 'content.danger.secondary' : undefined}
        />
      }
    >
      <FormattedMessageWrapper {...myListMessages.save} />
    </ButtonLink>
  )
}
